"use client";
import {
  Card,
  CardHeader,
  CardBody,
  Typography,
 
} from "@material-tailwind/react";
import Image from "next/image";
import Link from "next/link";

function StarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="h-5 w-5 text-yellow-700"
    >
      <path
        fillRule="evenodd"
        d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function ShowCard({ url, title, price1, price2,  }) {
  return (

    <Card className="min-w-full max-w-[14rem] shadow-lg">
      <Link href={'/products'}>
      <CardHeader floated={false} color="blue-gray " className="group relative">
        <Image
          height={200}
          width={220}
          src={url}
          alt="ui/ux review check"
          className="h-48 w-full object-contain"
        />
        <div className="to-bg-black-10 absolute inset-0 h-full w-full bg-gradient-to-tr from-transparent via-transparent to-black/60 " />
       
      </CardHeader>
      </Link>

      <CardBody>
        <div className="mb-3 flex items-center justify-between">
          <Typography variant="h5" color="blue-gray" className="font-medium myfont">
            {title}
          </Typography>
        </div>

        <Typography
          color="blue-gray"
          className="flex items-center gap-1.5 font-medium text-lg"
        >
          <span className="text-secondary fontbold myfont">{`Rs.${price1}`}</span>
          <del className="text-gray-700 mr-2 myfont">{`Rs.${price2}`}</del>
        </Typography>

        <Typography
          color="blue-gray"
          className="flex items-center gap-1.5 myfont"
        >
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
          (35)
        </Typography>
      </CardBody>
    </Card>
  );
}
